import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
import router from '@/router'

Vue.use(Vuex)
const state = {
  idToken: null,
  userId: '',
  user: null
}
const getters = {
  getUserID (state) {
    return state.userId
  },
  getToken: state => {
    return (state.idToken) ? state.idToken : null
  }
}
const mutations = {
  authUser (state, userData) {
    state.idToken = userData.user.qa
  },
  clearAuthUser (state) {
    state.idToken = null
    state.userId = null
  },
  setUserID (state, userData) {
    state.userId = userData
  }
}
const actions = {
  Signup ({commit}, authData) {
    console.log('Sign up gets called')
    firebase.auth().createUserWithEmailAndPassword(authData.email, authData.password)
      .then(user => {
        console.log('user signup', user)
        commit('authUser', user)
      }).catch(error => console.log(error))
    console.log('tokennnnnnnn', firebase.auth().currentUser.getIdToken())
  },
  Login ({commit}, authData) {
    firebase.auth().signInWithEmailAndPassword(authData.email, authData.password)
      .then(user => {
        if (user.user.displayName && user.user.displayName === 'Admin') {
          window.localStorage.setItem('hashed-entities', user.user.qa)
          // window.localStorage.setItem('Admin_Name', value.data.firstName+' '+value.data.lastName)
          window.localStorage.setItem('Admin_ID', user.user.email)
          window.localStorage.setItem('activeIndex', '1-1')
          console.log('token', user.user.qa)
          console.log('token', user)
          commit('authUser', user)
          commit('setUserID', user)
          router.push('/dashboard')
        } else {
          commit('setUserID', 'Error')
        }
      })
      .catch(error => {
        console.log(error)
        commit('setUserID', 'Error')
      })
  },
  Logout ({commit}) {
    localStorage.removeItem('hashed-entities')
    commit('clearAuthUser')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js